// ------------------------------------
// Tooltips
// ------------------------------------
var tippyInstance;

// Configurações padrão
tippy.setDefaultProps({
  allowHTML: true,
  theme: 'lp-light',
  maxWidth: 250,
  responsive: [
    {
      allowHTML: false,
    },
  ],
});

// Inicializa a instância do Tippy.js
function initTippy() {
  tippyInstance = tippy('[data-tippy-content]');
}
initTippy();
if ($(window).width() > 780) {
  setTimeout(() => { $('[data-tippy-content]').first()[0]._tippy.show() }, 3000);
}
